export default "__VITE_ASSET__Bvij$rAC__"